<app-site-header />
<section class="content-area-layout1">
    <section class="content-area-layout2">
        <h3>Customers</h3>
        <p>Optional Search Criteria:</p>
        <form [formGroup]="viewCustomersForm">
            <div class="field-container">
                <mat-form-field>
                    <mat-label>Last Name</mat-label>
                    <input matInput #input maxlength="50" formControlName="lastName" />
                </mat-form-field>
                <mat-form-field>
                    <mat-label>First Name</mat-label>
                    <input matInput #input maxlength="50" formControlName="firstName" />
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Business Name</mat-label>
                    <input matInput #input maxlength="50" formControlName="businessName" />
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Email</mat-label>
                    <input matInput #input maxlength="255" formControlName="email" />
                </mat-form-field>
                @if (userTypeEquals("employee")) {
                <app-dealer-names-component (messageEvent)="receiveMessage($event)"/>
                }
                <mat-form-field>
                    <mat-label>Customer ID</mat-label>
                    <input matInput #input maxlength="10" formControlName="customerId"/>
                </mat-form-field>
            </div>
        </form>

        <section style="padding-top: 1vw; padding-bottom: 1vw;">
            <button style="margin-right: 1vw;" mat-flat-button (click)="listCustomers()">Search</button>
            <button style="margin-right: 1vw;" mat-flat-button (click)="resetSearch()">Reset Search</button>
            @if (userHasRole("customer-editor")) {
            <button mat-flat-button (click)="addCustomer()">Add Customer</button>
            }
        </section>

        <p class="text-aerostar-orange">{{message}}</p>

        @if (customerCount > 0) {
        <p>Click on row to expand for additional information.</p>
        <div>
            <mat-accordion>
                <section class="mat-elevation-z2 mat-header-row">
                    <span class="first-name {{getAltCssClass('first-name')}}">First Name</span>
                    <span class="last-name {{getAltCssClass('last-name')}}">Last Name</span>
                    <span class="business-name {{getAltCssClass('business-name')}}">Business Name</span>
                    <span class="country {{getAltCssClass('country')}}">Country</span>
                    <span class="email {{getAltCssClass('email')}}">email</span>
                    <span class="phone {{getAltCssClass('phone')}}">Phone</span>
                    @if (userTypeEquals("employee")) {
                    <span class="dealer">Dealer</span>
                    }
                    @if (userHasRole("customer-editor")) {
                    <span class="actions {{getAltCssClass('actions')}}">Actions</span>
                    }
                    <span class="icon {{getAltCssClass('icon')}}"></span>
                </section>
                <mat-expansion-panel hideToggle *ngFor="let customer of customers">
                    <mat-expansion-panel-header class="mat-row">
                        <span class="first-name {{getAltCssClass('first-name')}}">{{customer.first_name}}</span>
                        <span class="last-name {{getAltCssClass('last-name')}}">{{customer.last_name}}</span>
                        <span
                            class="business-name {{getAltCssClass('business-name')}}">{{customer.business_name}}</span>
                        <span class="country {{getAltCssClass('country')}}">{{customer.country_code}}</span>
                        <span class="email {{getAltCssClass('email')}}">{{customer.email}}</span>
                        <span class="phone {{getAltCssClass('phone')}}">{{customer.phone}}</span>
                        @if (userTypeEquals("employee")) {
                        <span class="dealer">{{customer.dealer?.name}}</span>
                        }
                        @if (userHasRole("customer-editor")) {
                        <span class="actions {{getAltCssClass('actions')}}">
                            <ng-container matColumnDef="more-vert">
                                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="View and Update Actions"
                                    (click)=$event.stopPropagation()>
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <!-- The following "if" is only relevant when the user is
                                             an employee. If the user is a dealer or dealer rep
                                             then only customers associated with the dealer are
                                             returned from the backend. Additionally, backend security
                                             controls ensure that any update to a customer is limited
                                             to the update being made only by the associated dealer.
                                        -->
                                    @if (userDealerId == customer.dealer_id && customer.status == "A") {
                                    <button mat-menu-item (click)="updateCustomer(customer.id)">
                                        <span>Update Customer</span>
                                    </button>
                                    }
                                    @if (userHasRole("customer-admin")) {
                                    @if (customer.status == "A") {
                                    <button mat-menu-item (click)="inactivateCustomer(customer.id)">
                                        <span>Inactivate Customer</span>
                                    </button>
                                    } @else {
                                    <button mat-menu-item (click)="reactivateCustomer(customer.id)">
                                        <span>Reactivate Customer</span>
                                    </button>
                                    }
                                    }
                                    @if (isNonProd && userDealerId == customer.dealer_id && customer.status == "A") {
                                    <button mat-menu-item>
                                        <span (click)="deleteCustomer(customer.id)">Delete Customer<br><sup>(Limited to
                                                Non-Prod Env)</sup></span>
                                    </button>
                                    }
                                </mat-menu>
                            </ng-container>
                        </span>
                        }
                        <span class="icon {{getAltCssClass('icon')}}">@if (customer.status == "I") {<img
                                src="person-inactivated-icon.svg">}</span>
                    </mat-expansion-panel-header>
                    <div>
                        <hr>
                        <div class="customer-id">
                            <b>Customer ID:</b>&nbsp;&nbsp;{{customer.id}}
                        </div>
                        <div class="address-title">
                            <b>Address:</b>
                        </div>
                        <div class="address-info">
                            {{customer.address_line_1}}
                            <br>{{customer.address_line_2}}
                            <br>{{customer.address_line_3}}
                        </div>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

        <mat-paginator #paginator (page)="handlePageEvent($event)" [length]="customerCount" [pageSize]="pageSize"
            [disabled]="false" [showFirstLastButtons]="true" [pageSizeOptions]="[5, 10, 25]" [hidePageSize]="false"
            [pageIndex]="pageIndex" aria-label="Select page">
        </mat-paginator>
        }
        @if (customerCount == 0) {
        <p>No Customers found</p>
        }
    </section>
</section>